import React, { useState, useEffect } from "react";
import { Page, Card, Layout, IndexTable, Stack, Link, EmptyState, Text } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import pluralize from "../../../../utilities/pluralize";
import contentTypeOptions from "./contentTypeOptions";
import FieldsSkeletonIndex from "./SkeletonIndex";

import { TitleBar } from "@shopify/app-bridge-react";
import { useGetFields } from "../../../../hooks/queries/fields";
import { mobileTitle } from "../../../../utilities/mobile";

export default function FieldsIndex(props) {
  const { t } = useTranslation();
  const { data, isError } = useGetFields();
  const [fields, setFields] = useState(data);
  useEffect(() => setFields(data), [data]);

  function renderName(field) {
    return (
      <Stack alignment="center">
        <Stack vertical spacing="none">
          <Link
            monochrome
            dataPrimaryLink
            url={"/settings/fields/" + field.id}
          />
          <Text  variant="bodyMd" as="span" fontWeight="semibold">{field.name}</Text>
          <Text  variant="bodyMd" as="span" color="subdued">location.fields.{field.handle}
          </Text>
        </Stack>
      </Stack>
    );
  }

  function renderType(field) {
    const contentType = contentTypeOptions(t).filter(
      (ct) => ct.value === field.content_type
    )[0];

    return (
      <div style={{ margin: "5px 0" }}>
        <Stack spacing="tight" alignment="center">
          {contentType.prefix}
          <Text variant="bodyMd" as="span">{contentType.label}</Text>
        </Stack>
      </div>
    );
  }

  function renderValueCount(field) {
    return (
      <Text  variant="bodyMd" as="span" color="subdued">
        {pluralize(field.content_count, [
          t("settings.customFields.pluralization.location"), 
          t("settings.customFields.pluralization.locations")
        ])}
      </Text>
    );
  }

  const emptyState = (
    <EmptyState
      heading={t("settings.customFields.emptyState.heading")}
      // image="https://cdn.shopify.com/s/files/1/2376/3301/products/emptystate-files.png"
      action={{ content: t("settings.customFields.emptyState.createAction"), url: "/settings/fields/new" }}
    >
      <p>
        {t("settings.customFields.emptyState.description")}
      </p>
    </EmptyState>
  );

  if (isError) return <p>{t("settings.customFields.error")}</p>;
  if (!fields) return <FieldsSkeletonIndex />;

  return (
    <Page>
      <TitleBar
        title={mobileTitle(t("settings.customFields.title"), t("settings.common.breadcrumbs.settings"))}
        primaryAction={{
          content: t("settings.customFields.addField"),
          url: "/settings/fields/new",
        }}
        breadcrumbs={[{ content: t("settings.common.breadcrumbs.settings") }]}
      />
      <Layout>
        <Layout.Section>
          <Card>
            <IndexTable
              loading={fields === null}
              resourceName={{ 
                singular: t("settings.customFields.resourceName.singular"), 
                plural: t("settings.customFields.resourceName.plural") 
              }}
              itemCount={fields ? fields.length : 0}
              // itemCount={0}
              selectable={false}
              emptyState={emptyState}
              headings={[
                { title: t("settings.customFields.headings.name") },
                { title: t("settings.customFields.headings.contentType") },
                { title: t("settings.customFields.headings.usedIn") },
              ]}
            >
              {fields &&
                fields.map((field, index) => (
                  <IndexTable.Row
                    id={field.id}
                    key={field.id}
                    position={index}
                    data-primary-link={"/test"}
                  >
                    <IndexTable.Cell>{renderName(field)}</IndexTable.Cell>
                    <IndexTable.Cell>{renderType(field)}</IndexTable.Cell>
                    <IndexTable.Cell>{renderValueCount(field)}</IndexTable.Cell>
                  </IndexTable.Row>
                ))}
            </IndexTable>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}

// import { Sortable } from "@shopify/draggable";
// const sortable = new Sortable(
//   document.querySelectorAll(".Polaris-IndexTable__Table tbody"),
//   {
//     draggable: "tr",
//     handle: ".Polaris-Icon",
//     mirror: {
//       appendTo: ".Polaris-IndexTable__Table tbody",
//       constrainDimensions: true,
//       xAxis: false,
//     },
//   }
// );

/* <div style={{ cursor: "grab" }}>
  <Icon source={DragHandleMinor} color="subdued" />
</div>; */
